import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { PerssianLabel } from "./locales/fa/translation";
import { EnglishLabel } from "./locales/en/translation";
import { FrenchLabel } from "./locales/fr/translation";
import { ArabicLabel } from "./locales/ar/translation";
import { RomanianLabel } from "./locales/ro/translation";
import { DutchLabel } from "./locales/nl/translation";
import { EspanishLabel } from "./locales/es/translation";
import { AustrianGermanLabel } from "./locales/de/translation";
import { Azerbaijani } from "./locales/aze/translation";
import { RussianLabel } from "./locales/rus/translation";
import { PortugueseLabel } from "./locales/pt/translation";
import { GreekLabel } from "./locales/el/translation";
import { ChineseSimplifiedLabel } from "./locales/zh/translation";
import { CzechLabel } from "./locales/cs/translation";

import LanguageDetector from 'i18next-browser-languagedetector';

i18n.use(initReactI18next).use(LanguageDetector)
.init({
  resources: {
    en: {
      translation: EnglishLabel,
    },
    el: {
      translation: GreekLabel,
    },
    pt: {
      translation: PortugueseLabel,
    },
    fa: {
      translation: PerssianLabel,
    },
    fr: {
      translation: FrenchLabel,
    },
    ar: {
      translation: ArabicLabel,
    },
    ro: {
      translation: RomanianLabel,
    },
    nl: {
      translation: DutchLabel,
    },
    es: {
      translation: EspanishLabel,
    },
    'de-AT': {
      translation: AustrianGermanLabel,
    },
    'zh': {
      translation: ChineseSimplifiedLabel,
    },
    aze: {
      translation: Azerbaijani,
    },
    rus: {
      translation: RussianLabel,
    },
    cs :{
      translation : CzechLabel
    }

  },
  lng: "en",
  debug: true,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
